import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context39; _forEachInstanceProperty(_context39 = ownKeys(source, true)).call(_context39, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context40; _forEachInstanceProperty(_context40 = ownKeys(source)).call(_context40, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import isEqual from 'react-fast-compare';
import createContext from 'create-react-context';
import { isFunction, isPromise, noop, concatenateErrors, flattenArray } from './utils';
import { get, set, unset, debounce } from 'lodash';

var _createContext = createContext(),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

var ReactForms =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactForms, _Component);

  function ReactForms(props) {
    var _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21;

    var _this;

    _classCallCheck(this, ReactForms);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactForms).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fields: {},
      meta: null,
      submitCount: 0,
      isSubmitting: false,
      isValidating: false
    });

    _defineProperty(_assertThisInitialized(_this), "blockSubmission", false);

    _defineProperty(_assertThisInitialized(_this), "pendingStateUpdates", []);

    _defineProperty(_assertThisInitialized(_this), "flushBatchedState", debounce(function () {
      var _context;

      var callbacks = [];

      var newState = _reduceInstanceProperty(_context = _this.pendingStateUpdates).call(_context, function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            state = _ref2[0],
            callback = _ref2[1];

        acc = _objectSpread({}, acc, {}, state(acc));
        callbacks.push(callback);
        return acc;
      }, _this.state);

      _this.pendingStateUpdates = [];

      _this.setState(newState, function () {
        _forEachInstanceProperty(callbacks).call(callbacks, function (c) {
          return c();
        });
      });
    }, 20));

    _this.registerField = _bindInstanceProperty(_context2 = _this.registerField).call(_context2, _assertThisInitialized(_this));
    _this.unregisterField = _bindInstanceProperty(_context3 = _this.unregisterField).call(_context3, _assertThisInitialized(_this));
    _this.setFormState = _bindInstanceProperty(_context4 = _this.setFormState).call(_context4, _assertThisInitialized(_this));
    _this.setValues = _bindInstanceProperty(_context5 = _this.setValues).call(_context5, _assertThisInitialized(_this));
    _this.setFieldValue = _bindInstanceProperty(_context6 = _this.setFieldValue).call(_context6, _assertThisInitialized(_this));
    _this.setErrors = _bindInstanceProperty(_context7 = _this.setErrors).call(_context7, _assertThisInitialized(_this));
    _this.setFieldError = _bindInstanceProperty(_context8 = _this.setFieldError).call(_context8, _assertThisInitialized(_this));
    _this.setTouched = _bindInstanceProperty(_context9 = _this.setTouched).call(_context9, _assertThisInitialized(_this));
    _this.setFieldTouched = _bindInstanceProperty(_context10 = _this.setFieldTouched).call(_context10, _assertThisInitialized(_this));
    _this.setMeta = _bindInstanceProperty(_context11 = _this.setMeta).call(_context11, _assertThisInitialized(_this));
    _this.resetForm = _bindInstanceProperty(_context12 = _this.resetForm).call(_context12, _assertThisInitialized(_this));
    _this.getValues = _bindInstanceProperty(_context13 = _this.getValues).call(_context13, _assertThisInitialized(_this));
    _this.getTouched = _bindInstanceProperty(_context14 = _this.getTouched).call(_context14, _assertThisInitialized(_this));
    _this.getErrors = _bindInstanceProperty(_context15 = _this.getErrors).call(_context15, _assertThisInitialized(_this));
    _this.runValidations = _bindInstanceProperty(_context16 = _this.runValidations).call(_context16, _assertThisInitialized(_this));
    _this.executeSubmit = _bindInstanceProperty(_context17 = _this.executeSubmit).call(_context17, _assertThisInitialized(_this));
    _this.submitForm = _bindInstanceProperty(_context18 = _this.submitForm).call(_context18, _assertThisInitialized(_this));
    _this.getComputedProps = _bindInstanceProperty(_context19 = _this.getComputedProps).call(_context19, _assertThisInitialized(_this));
    _this.getFormHelpers = _bindInstanceProperty(_context20 = _this.getFormHelpers).call(_context20, _assertThisInitialized(_this));
    _this.getFormState = _bindInstanceProperty(_context21 = _this.getFormState).call(_context21, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReactForms, [{
    key: "registerField",
    value: function registerField(name, _ref3) {
      var id = _ref3.id,
          initialValue = _ref3.initialValue,
          initialTouched = _ref3.initialTouched,
          initialError = _ref3.initialError,
          validate = _ref3.validate,
          setValue = _ref3.setValue,
          setTouched = _ref3.setTouched,
          setError = _ref3.setError,
          reset = _ref3.reset;
      this.setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _objectSpread({}, prevState.fields, _defineProperty({}, name, {
            id: id,
            initialValue: initialValue,
            value: initialValue,
            touched: initialTouched,
            error: initialError,
            validate: validate,
            setValue: setValue,
            setTouched: setTouched,
            setError: setError,
            reset: reset
          }))
        });
      });
    }
  }, {
    key: "unregisterField",
    value: function unregisterField(id) {
      this.setFormState(function (prevState) {
        var _context22;

        var fields = prevState.fields;

        var newFields = _objectSpread({}, fields); // Find and unregister by ID so that fields can swap names
        // without then unregistering the field that swapped with them


        var name = _findInstanceProperty(_context22 = _Object$keys(newFields)).call(_context22, function (fieldName) {
          if (fields[fieldName].id === id) {
            return true;
          }
        });

        if (name) {
          unset(newFields, name);
          return _objectSpread({}, prevState, {
            fields: newFields
          });
        } else {
          return null;
        }
      });
    }
  }, {
    key: "batchState",
    value: function batchState(state, callback) {
      this.pendingStateUpdates.push([state, callback]);
      this.flushBatchedState();
    }
  }, {
    key: "setFormState",
    value: function setFormState(state) {
      var _this2 = this;

      return new _Promise(function (resolve) {
        _this2.batchState(state, resolve);
      });
    }
  }, {
    key: "setValues",
    value: function setValues(values) {
      var _context23;

      var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var shouldValidate = arguments.length > 2 ? arguments[2] : undefined;
      var fields = this.state.fields;
      var promises = [];

      _forEachInstanceProperty(_context23 = _Object$keys(fields)).call(_context23, function (name) {
        var value = get(values, name);

        if (!merge || merge && value !== undefined) {
          promises.push(fields[name].setValue(value, shouldValidate));
        }
      });

      return _Promise.all(promises);
    }
  }, {
    key: "setFieldValue",
    value: function setFieldValue(name, value, shouldValidate) {
      var fields = this.state.fields;

      if (!fields[name]) {
        throw new Error("Field ".concat(name, " does not exist"));
      } else {
        return fields[name].setValue(value, shouldValidate);
      }
    }
  }, {
    key: "setErrors",
    value: function setErrors(errors) {
      var _context24;

      var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shouldTouch = arguments.length > 2 ? arguments[2] : undefined;
      var fields = this.state.fields;
      var promises = [];

      _forEachInstanceProperty(_context24 = _Object$keys(fields)).call(_context24, function (name) {
        var error = get(errors, name, null);

        if (!merge || merge && error === null) {
          promises.push(fields[name].setError(error, shouldTouch));
        }
      });

      return _Promise.all(promises);
    }
  }, {
    key: "setFieldError",
    value: function setFieldError(name, error, shouldTouch) {
      var fields = this.state.fields;

      if (!fields[name]) {
        throw new Error("Field ".concat(name, " does not exist"));
      } else {
        return fields[name].setError(error, shouldTouch);
      }
    }
  }, {
    key: "setTouched",
    value: function setTouched(touched, shouldValidate) {
      var _context25;

      var fields = this.state.fields;
      var promises = [];

      _forEachInstanceProperty(_context25 = _Object$keys(fields)).call(_context25, function (name) {
        promises.push(fields[name].setTouched(get(touched, name, false), shouldValidate));
      });

      return _Promise.all(promises);
    }
  }, {
    key: "setFieldTouched",
    value: function setFieldTouched(name, touched, shouldValidate) {
      var fields = this.state.fields;

      if (!fields[name]) {
        throw new Error("Field ".concat(name, " does not exist"));
      } else {
        return fields[name].setTouched(touched, shouldValidate);
      }
    }
  }, {
    key: "setMeta",
    value: function setMeta(meta) {
      return this.setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          meta: meta
        });
      });
    }
  }, {
    key: "resetForm",
    value: function resetForm(values, shouldValidate) {
      var _context26;

      var fields = this.state.fields;
      var promises = [];

      _forEachInstanceProperty(_context26 = _Object$keys(fields)).call(_context26, function (name) {
        promises.push(fields[name].reset(get(values, name), shouldValidate));
      });

      return _Promise.all(promises);
    }
  }, {
    key: "getInitialValues",
    value: function getInitialValues() {
      var _context27;

      var fields = this.state.fields;
      return _reduceInstanceProperty(_context27 = _Object$keys(fields)).call(_context27, function (acc, name) {
        set(acc, name, fields[name].initialValue);
        return acc;
      }, {});
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _context28;

      var fields = this.state.fields;
      return _reduceInstanceProperty(_context28 = _Object$keys(fields)).call(_context28, function (acc, name) {
        set(acc, name, fields[name].value);
        return acc;
      }, {});
    }
  }, {
    key: "getTouched",
    value: function getTouched() {
      var _context29;

      var fields = this.state.fields;
      return _reduceInstanceProperty(_context29 = _Object$keys(fields)).call(_context29, function (acc, name) {
        set(acc, name, fields[name].touched);
        return acc;
      }, {});
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var _context30;

      var fields = this.state.fields;
      return _reduceInstanceProperty(_context30 = _Object$keys(fields)).call(_context30, function (acc, name) {
        if (fields[name].error !== null) {
          set(acc, name, fields[name].error);
        }

        return acc;
      }, {});
    }
  }, {
    key: "startSubmit",
    value: function startSubmit() {
      var _context31;

      var fields = this.state.fields;
      this.setTouched(_reduceInstanceProperty(_context31 = _Object$keys(fields)).call(_context31, function (acc, name) {
        set(acc, name, true);
        return acc;
      }, {}), false);
      return this.setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          submitCount: prevState.submitCount + 1
        });
      });
    }
  }, {
    key: "runValidations",
    value: function runValidations() {
      var _context32,
          _this3 = this;

      var fields = this.state.fields;
      var validate = this.props.validate;
      var values = this.getValues();
      this.setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          isValidating: true
        });
      });
      var asyncValidators = [];
      var syncErrors = []; // Validate all fields then the form
      // If both have validated the same field use
      // the field specific error
      // If there are async validators then overwrite
      // the sync errors with those

      _forEachInstanceProperty(_context32 = _Object$keys(fields)).call(_context32, function (name) {
        var fieldValidator = fields[name].validate;

        if (isFunction(fieldValidator)) {
          var maybePromisedError = fieldValidator(fields[name].value, _this3.getFormHelpers(true));

          if (isPromise(maybePromisedError)) {
            asyncValidators.push(_defineProperty({}, name, maybePromisedError));
          } else {
            syncErrors.push(_defineProperty({}, name, maybePromisedError));
          }
        } else {
          // Make sure every error has a null value if
          // no validation is performed
          syncErrors.push(_defineProperty({}, name, null));
        }
      });

      if (isFunction(validate)) {
        var maybePromisedErrors = validate(values, this.getFormHelpers(true));

        if (isPromise(maybePromisedErrors)) {
          asyncValidators.push(maybePromisedErrors);
        } else {
          syncErrors.push(maybePromisedErrors);
        }
      }

      if (asyncValidators.length === 0) {
        this.setFormState(function (prevState) {
          return _objectSpread({}, prevState, {
            isValidating: false
          });
        });
        return concatenateErrors(syncErrors);
      } else {
        // Wrap this in a promise to be able to control the
        // resolved value so we can preserve the field name
        // that the error is attached to
        return new _Promise(
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2(resolve) {
            var _context35;

            var asyncErrors;
            return _regeneratorRuntime.wrap(function _callee2$(_context36) {
              while (1) {
                switch (_context36.prev = _context36.next) {
                  case 0:
                    _context36.next = 2;
                    return _Promise.all(flattenArray(_mapInstanceProperty(asyncValidators).call(asyncValidators, function (validator) {
                      if (!isPromise(validator)) {
                        var _context33;

                        return _mapInstanceProperty(_context33 = _Object$entries(validator)).call(_context33, function (_ref5) {
                          var _ref6 = _slicedToArray(_ref5, 2),
                              key = _ref6[0],
                              value = _ref6[1];

                          return new _Promise(
                          /*#__PURE__*/
                          function () {
                            var _ref7 = _asyncToGenerator(
                            /*#__PURE__*/
                            _regeneratorRuntime.mark(function _callee(resolve) {
                              var error;
                              return _regeneratorRuntime.wrap(function _callee$(_context34) {
                                while (1) {
                                  switch (_context34.prev = _context34.next) {
                                    case 0:
                                      _context34.next = 2;
                                      return value;

                                    case 2:
                                      error = _context34.sent;
                                      resolve(_defineProperty({}, key, error));

                                    case 4:
                                    case "end":
                                      return _context34.stop();
                                  }
                                }
                              }, _callee);
                            }));

                            return function (_x2) {
                              return _ref7.apply(this, arguments);
                            };
                          }());
                        });
                      } else {
                        return validator;
                      }
                    })));

                  case 2:
                    asyncErrors = _context36.sent;

                    _this3.setFormState(function (prevState) {
                      return _objectSpread({}, prevState, {
                        isValidating: false
                      });
                    });

                    resolve(_objectSpread({}, concatenateErrors(_concatInstanceProperty(_context35 = []).call(_context35, syncErrors, _toConsumableArray(asyncErrors)))));

                  case 5:
                  case "end":
                    return _context36.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "executeSubmit",
    value: function () {
      var _executeSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var handleSubmit, values, errors, isValid, submit, submission;
        return _regeneratorRuntime.wrap(function _callee3$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                handleSubmit = this.props.handleSubmit;
                _context37.prev = 1;
                values = this.getValues();
                errors = this.getErrors();
                isValid = _Object$keys(errors).length <= 0;

                if (!isValid) {
                  _context37.next = 14;
                  break;
                }

                this.setFormState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    isSubmitting: true
                  });
                });
                submit = handleSubmit(values, this.getFormHelpers(true));

                if (!isPromise(submit)) {
                  _context37.next = 13;
                  break;
                }

                _context37.next = 11;
                return submit;

              case 11:
                submission = _context37.sent;
                return _context37.abrupt("return", submission);

              case 13:
                return _context37.abrupt("return", submit);

              case 14:
                return _context37.abrupt("return", false);

              case 15:
                _context37.prev = 15;
                _context37.next = 18;
                return this.setFormState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    isSubmitting: false
                  });
                });

              case 18:
                return _context37.finish(15);

              case 19:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee3, this, [[1,, 15, 19]]);
      }));

      function executeSubmit() {
        return _executeSubmit.apply(this, arguments);
      }

      return executeSubmit;
    }()
  }, {
    key: "submitForm",
    value: function () {
      var _submitForm = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(e) {
        var isSubmitting, maybePromisedErrors, errors;
        return _regeneratorRuntime.wrap(function _callee4$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                isSubmitting = this.state.isSubmitting;

                if (e && e.preventDefault) {
                  e.preventDefault();
                }

                if (!(isSubmitting || this.blockSubmission)) {
                  _context38.next = 4;
                  break;
                }

                return _context38.abrupt("return", false);

              case 4:
                this.blockSubmission = true;
                _context38.prev = 5;
                _context38.next = 8;
                return this.startSubmit();

              case 8:
                maybePromisedErrors = this.runValidations();

                if (!isPromise(maybePromisedErrors)) {
                  _context38.next = 17;
                  break;
                }

                _context38.next = 12;
                return maybePromisedErrors;

              case 12:
                errors = _context38.sent;
                _context38.next = 15;
                return this.setErrors(errors, false, true);

              case 15:
                _context38.next = 19;
                break;

              case 17:
                _context38.next = 19;
                return this.setErrors(maybePromisedErrors, false, true);

              case 19:
                _context38.next = 21;
                return this.executeSubmit();

              case 21:
                return _context38.abrupt("return", _context38.sent);

              case 22:
                _context38.prev = 22;
                this.blockSubmission = false;
                return _context38.finish(22);

              case 25:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee4, this, [[5,, 22, 25]]);
      }));

      function submitForm(_x3) {
        return _submitForm.apply(this, arguments);
      }

      return submitForm;
    }()
  }, {
    key: "getComputedProps",
    value: function getComputedProps() {
      var initialValues = this.getInitialValues();
      var values = this.getValues();
      var errors = this.getErrors();
      return {
        isDirty: !isEqual(initialValues, values),
        isValid: _Object$keys(errors).length <= 0
      };
    }
  }, {
    key: "getFormHelpers",
    value: function getFormHelpers(withProps) {
      var _this$state = this.state,
          meta = _this$state.meta,
          submitCount = _this$state.submitCount;
      var outerProps = this.props.outerProps;
      return _objectSpread({}, outerProps && withProps ? {
        props: outerProps
      } : {}, {
        meta: meta,
        submitCount: submitCount,
        setValues: this.setValues,
        setFieldValue: this.setFieldValue,
        setErrors: this.setErrors,
        setFieldError: this.setFieldError,
        setTouched: this.setTouched,
        setFieldTouched: this.setFieldTouched,
        setMeta: this.setMeta,
        resetForm: this.resetForm,
        submitForm: this.submitForm
      });
    }
  }, {
    key: "getFormState",
    value: function getFormState() {
      var _this$state2 = this.state,
          fields = _this$state2.fields,
          meta = _this$state2.meta,
          submitCount = _this$state2.submitCount,
          restState = _objectWithoutProperties(_this$state2, ["fields", "meta", "submitCount"]);

      return _objectSpread({}, this.getComputedProps(), {}, this.getFormHelpers(false), {}, restState, {
        values: this.getValues(),
        touched: this.getTouched(),
        errors: this.getErrors()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          children = _this$props.children,
          validate = _this$props.validate,
          initialValues = _this$props.initialValues,
          validateOnMount = _this$props.validateOnMount,
          validateOnChange = _this$props.validateOnChange,
          validateOnBlur = _this$props.validateOnBlur,
          touchOnMount = _this$props.touchOnMount,
          touchOnChange = _this$props.touchOnChange,
          touchOnBlur = _this$props.touchOnBlur,
          shouldUnregister = _this$props.shouldUnregister;
      var formState = this.getFormState();
      return React.createElement(Provider, {
        value: _objectSpread({}, formState, {
          initialValues: initialValues,
          validateOnMount: validateOnMount,
          validateOnChange: validateOnChange,
          validateOnBlur: validateOnBlur,
          touchOnMount: touchOnMount,
          touchOnChange: touchOnChange,
          touchOnBlur: touchOnBlur,
          shouldUnregister: shouldUnregister,
          registerField: this.registerField,
          unregisterField: this.unregisterField,
          validateForm: validate,
          setFormState: this.setFormState,
          getFormHelpers: this.getFormHelpers
        })
      }, isFunction(children) ? children(formState) : isFunction(render) ? render(formState) : null);
    }
  }]);

  return ReactForms;
}(Component);

_defineProperty(ReactForms, "defaultProps", {
  validateOnMount: false,
  validateOnChange: true,
  validateOnBlur: true,
  touchOnMount: false,
  touchOnChange: true,
  touchOnBlur: true,
  shouldUnregister: true,
  handleSubmit: noop
});

var AsyncValuesWrapper =
/*#__PURE__*/
function (_Component2) {
  _inherits(AsyncValuesWrapper, _Component2);

  function AsyncValuesWrapper() {
    var _getPrototypeOf2, _context41;

    var _this4;

    _classCallCheck(this, AsyncValuesWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this4 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AsyncValuesWrapper)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context41 = [this]).call(_context41, args)));

    _defineProperty(_assertThisInitialized(_this4), "initialized", _this4.getAsyncValuesReady());

    _defineProperty(_assertThisInitialized(_this4), "getKey", function () {
      if (!_this4.initialized) {
        if (_this4.getAsyncValuesReady()) {
          _this4.initialized = true;
        } else {
          return false;
        }
      }

      return _this4.initialized;
    });

    return _this4;
  }

  _createClass(AsyncValuesWrapper, [{
    key: "getAsyncValuesReady",
    value: function getAsyncValuesReady() {
      var _this$props2 = this.props,
          asyncValuesReady = _this$props2.asyncValuesReady,
          outerProps = _this$props2.outerProps;

      if (isFunction(asyncValuesReady)) {
        return asyncValuesReady(outerProps);
      } else {
        return asyncValuesReady;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          asyncValuesReady = _this$props3.asyncValuesReady,
          rest = _objectWithoutProperties(_this$props3, ["asyncValuesReady"]);

      return React.createElement(ReactForms, _extends({
        key: this.getKey()
      }, rest));
    }
  }]);

  return AsyncValuesWrapper;
}(Component);

_defineProperty(AsyncValuesWrapper, "defaultProps", {
  asyncValuesReady: true
});

export var FormConsumer = Consumer;
export default AsyncValuesWrapper;